import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/move-to-next-stage.svg (also FDS MoveToNextStage).
export const MoveToNextStageIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function MoveToNextStageIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 16 16"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M16 10H11V12H16V10Z" />
        <path d="M5 4H9V2H5C2.243 2 0 4.243 0 7C0 9.757 2.243 12 5 12V15L9 11L5 7V10C3.346 10 2 8.654 2 7C2 5.346 3.346 4 5 4Z" />
        <path d="M16 2H11V4H16V2Z" />
      </BaseIcon>
    );
  },
);
